import { useMutation } from 'react-query';
import OrdersApi, { ICloneBatchResult, ICloneOrderCopyDetails } from '../../OrdersApi';

export function useCloneOrderMutation(orderId: number) {
    const mutation = useMutation(
        (variables: { count: number; copies: ICloneOrderCopyDetails[] }): Promise<ICloneBatchResult> =>
            OrdersApi.cloneBatch(orderId, variables.count, variables.copies)
    );

    return (count: number, copies: ICloneOrderCopyDetails[]) =>
        mutation.mutateAsync({ count, copies });
}
